import { create } from 'zustand';

/** Whether the "Trợ giúp & góp ý" dialog is open. Lives outside the sidebar
 *  footer item so the phone Thêm sheet can open the same dialog (its row
 *  calls `setOpen(true)` then closes itself) without either owning the other. */
interface HelpDialogState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useHelpDialogStore = create<HelpDialogState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
